import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
// import NextOfKin from './NextOfKin';
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { NewbornSidebar } from "../Layouts/NewbornSidebar";

import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class NewbornProcedures extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      history: "",
      labResults: "",
      diagnosis: "",
      plan: "",
      medication: "",
      continuousMedication: "",
      loading: false,
      response: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  getTableValues(event) {
    this.formatTableOutput(event);
  }

  formatTableOutput(data) {
    // console.log(data);
    let tableobj = {}; //empty obj
    for (let i = 0; i < data.length; i++) {
      let tempobj = {};
      tempobj["Date"] = data[i][0];
      tempobj["Type Of Investigation"] = data[i][1];
      tempobj["Results"] = data[i][2];
      tempobj["Normal range"] = data[i][3];
      tableobj[i] = tempobj;
    }
    this.state.labResults = JSON.stringify(tableobj);
  }

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    let payload = {
      history: this.state.history,
      labResults: this.state.labResults,
      diagnosis: this.state.diagnosis,
      plan: this.state.plan,
      medication: this.state.medication,
      continuousMedication: this.state.continuousMedication,
    };

    console.log(payload);

    axios
      .post(this.api_url+"newborn/procedures", payload, {
        headers: headers,
      })
      .then((response) => {
        // console.log(response)
        this.setState({ response: response });
        if (response.status == 200) {
          $("#SubmitError").fadeOut("fast");
          $(".alert-success").show();
          setTimeout(function (props) {
            // window.location.href = '/newbornunit/treatment/counselling'
          }, 1000);
        } else {
          $(".alert-success").fadeOut("fast");
          $("#SubmitError").show();
        }
      })
      .catch((error) => {
        this.state.loading = false;
        $(".alert-success").fadeOut("fast");
        $("#SubmitError").show();
        console.log(error);
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      history,
      labResults,
      diagnosis,
      plan,
      medication,
      continuousMedication,
      loading,
    } = this.state;

    const data = [["", "", "", ""]];
    const columns = [
      "Date",
      "Type Of Investigation",
      "Results",
      "Normal range",
    ];

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <NewbornSidebar></NewbornSidebar>

        <main className="content-container">
          <div className="container p-2">
            <div className="row pl-2 text-lg-center font-weight-bold p-1">
              <p className="text-capitalize" style={font16}>
                Newborn Procedures
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      History
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={history}
                      name="history"
                      type="text"
                      rows="6"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <MDBCard>
                      <MDBCardHeader
                        tag="h5"
                        className="text-center font-weight-bold text-capitalise py-4"
                      >
                        LABORATORY AND DIAGNOSTIC TEST
                      </MDBCardHeader>
                      <MDBCardBody>
                        <MDBTableEditable
                          onChange={(value) => this.handleTableChange(value)}
                          getValue={(value) => this.getTableValues(value)}
                          myParentTrigger={this.state.myParentTrigger}
                          id="editablecard"
                          data={data}
                          columns={columns}
                          striped
                          bordered
                        />
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Diagnosis
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={diagnosis}
                      name="diagnosis"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Plan{" "}
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={plan}
                      name="plan"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Medication
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={medication}
                      name="medication"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Continuous Medication
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={continuousMedication}
                      name="continuousMedication"
                      type="text"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading == false ? (
                      <span>Submit</span>
                    ) : (
                      <span>Loading</span>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewbornProcedures;
